import React,{ useState} from 'react';
import{Link,Redirect} from 'react-router-dom';
import css from './Card.module.css';
import{addItem} from '../../Cart/CartHelpers';

function Card(props) {
    const [redirect,setRedirect] = useState(false);
    const [showCart,setShowCart] = useState(true)
    const addToCart=()=>{
        addItem(props.product,()=>{
            setRedirect(true);
            setShowCart(false);  
        });
    };
    const showRedirect=(redirect)=>{
        let path = window.location.href.split('/');
        if(redirect)
        {
            if(path[path.length-1].length>0){
                if(path[path.length-2]==='category')
                {
                    return <Redirect to={`/category/${path[path.length-1]}`}/>;
                }
                return <Redirect to={`/product/${path[path.length-1]}`}/>;
            }
            return <Redirect to="/"/>;
        }
    };


    const showAddtocart=(showCart)=>(
        showCart&&(<button onClick={addToCart} className={`${css.Icon} btn btn-primary btn-sm`}><i className="fas fa-shopping-cart mx-2"></i></button>)
    
    )

    return (
       <React.Fragment>
           <div className={`${css.Card} card h-100`}>
            <img className={`${css.Image} card-img-top mx-auto`} src={`https://nhathuocvantien.herokuapp.com/api/product/photo/${props.product._id}`} alt={props.product.name}/>
            <div className={`card-body ${css.Cardbody}`}>
                <h5 className="card-title">{props.product.name.slice(0,30)+"..."}</h5>
                <p className={`card-text ${css.Cardtext}`}>{props.product.description.slice(0,45)+"..."}</p>
                <p className={`text-center text-danger ${css.Pricetext}`}>{props.product.price+".000"}<sup>đ</sup></p>
                {/* <Link to="#" className="btn btn-info mr-1 pc">XEM CHI TIẾT</Link>
                <Link to="#" className="btn btn-primary pc">THÊM VÀO GIỎ</Link> */}
                <p className="text-center"><Link className={`${css.Icon} btn btn-info mr-1`} to={`/product/${props.product._id}`} ><i className="fas fa-eye"></i></Link>
               {showAddtocart(showCart)}
               </p>
                {showRedirect(redirect)}
            </div>
            </div>    
            
        
       </React.Fragment>
    );
}

export default Card;